/* STNDR. storefront — behaviour ported from the design prototype.
   Motion, timings and easing are unchanged; product data, options and the
   bag are wired to the live Shopify cart. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  var CFG = window.STNDR || {};

  /* ---------- entrance ---------- */
  document.querySelectorAll('.hero__type .cell>span').forEach(function (s, i) {
    s.style.transitionDelay = (0.08 * i + 0.2) + 's';
  });
  addEventListener('load', function () { body.classList.add('ready'); });
  setTimeout(function () { body.classList.add('ready'); }, 700);

  /* ---------- marquee ---------- */
  var strip = document.getElementById('strip');
  var x = 0, half = 0;
  if (strip) {
    var items = [];
    try { items = JSON.parse(strip.getAttribute('data-items') || '[]'); } catch (e) { items = []; }
    if (items.length) {
      var esc = document.createElement('div');
      var unit = '<span>' + items.map(function (t) {
        esc.textContent = t;
        return esc.innerHTML + '<i></i>';
      }).join('') + '</span>';
      strip.innerHTML = unit.repeat(8);
    }
    half = strip.scrollWidth / 2;
    addEventListener('resize', function () { half = strip.scrollWidth / 2; });
  }

  /* ---------- parallax + marquee loop ---------- */
  var type = document.getElementById('type');
  var stage = document.getElementById('stage');
  var pars = document.querySelectorAll('[data-par]');
  var cur = 0;

  function loop() {
    if (!reduce) {
      if (strip) {
        x -= 0.45;
        if (half && -x >= half) x += half;
        strip.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      }
      cur += (scrollY - cur) * 0.085;
      pars.forEach(function (p) {
        var r = p.parentElement.getBoundingClientRect();
        if (r.bottom > 0 && r.top < innerHeight) {
          var g = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          p.style.transform = 'translateY(' + (g * -5.5).toFixed(2) + '%)';
        }
      });
      if (type && stage && cur < innerHeight * 1.25) {
        type.style.transform = 'translateX(-50%) translateY(' + (cur * 0.22).toFixed(2) + 'px)';
        stage.style.transform = 'translateX(-50%) translateY(' + (cur * -0.06).toFixed(2) + 'px)';
      }
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  /* ---------- header hide on scroll down ---------- */
  var bar = document.getElementById('bar'), last = 0;
  if (bar) {
    addEventListener('scroll', function () {
      var y = scrollY;
      bar.classList.toggle('up', y > last && y > 420);
      last = y;
    }, { passive: true });
  }

  /* ---------- reveals ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('[data-io]').forEach(function (s) {
    io.observe(s);
    s.querySelectorAll('.fade').forEach(function (el, i) { el.style.transitionDelay = (0.09 * i + 0.08) + 's'; });
    s.querySelectorAll('.tri,.svc__i').forEach(function (el, i) { el.style.transitionDelay = (0.11 * i) + 's'; });
  });
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); cio.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.card').forEach(function (el, i) {
    el.style.transitionDelay = (i % 4 * 0.08) + 's';
    cio.observe(el);
  });

  /* ---------- toast ---------- */
  var toast = document.getElementById('toast'), tt;
  function say(m) {
    if (!toast) return;
    toast.textContent = m;
    toast.classList.add('on');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('on'); }, 2200);
  }

  /* ---------- bag ---------- */
  var bagN = document.getElementById('bagN');
  function setBag(n) { if (bagN) bagN.textContent = '(' + n + ')'; }
  setBag(CFG.cartCount || 0);

  var bagBtn = document.getElementById('bagBtn');
  if (bagBtn) bagBtn.addEventListener('click', function () { location.href = CFG.routes.cart; });
  var searchBtn = document.getElementById('searchBtn');
  if (searchBtn) searchBtn.addEventListener('click', function () { location.href = CFG.routes.search; });
  var accountBtn = document.getElementById('accountBtn');
  if (accountBtn) accountBtn.addEventListener('click', function () { location.href = CFG.routes.account; });

  /* ---------- wishlist (persisted locally) ---------- */
  var WKEY = 'stndr:wishlist';
  var wishSet;
  try { wishSet = new Set(JSON.parse(localStorage.getItem(WKEY) || '[]')); } catch (e) { wishSet = new Set(); }
  var wishN = document.getElementById('wishN');
  function saveWish() {
    try { localStorage.setItem(WKEY, JSON.stringify([].slice.call(wishSet))); } catch (e) { /* private mode */ }
    if (wishN) wishN.textContent = '(' + wishSet.size + ')';
  }
  document.querySelectorAll('.card').forEach(function (card) {
    var w = card.querySelector('.wish');
    if (!w) return;
    var h = card.dataset.handle;
    if (wishSet.has(h)) w.classList.add('on');
    w.addEventListener('click', function (e) {
      e.stopPropagation();
      w.classList.toggle('on');
      if (w.classList.contains('on')) wishSet.add(h); else wishSet.delete(h);
      saveWish();
    });
  });
  saveWish();

  /* ---------- product detail ---------- */
  var pdp = document.getElementById('pdp');
  var lastFocus = null, current = null, picked = {}, virtualSize = null;

  var GUIDE = {
    top: [['Size', 'Chest', 'Length'], ['XS', '96', '66'], ['S', '101', '68'], ['M', '106', '70'], ['L', '112', '72'], ['XL', '118', '74']],
    bottom: [['Size', 'Waist', 'Inseam'], ['28', '71', '76'], ['30', '76', '78'], ['32', '81', '80'], ['34', '86', '80'], ['36', '91', '82'], ['38', '96', '82']]
  };

  function isColour(name) { return /colou?r/i.test(name || ''); }

  /* Product descriptions can arrive as markup, or HTML-escaped markup (some of
     the catalogue is stored double-escaped). Decode via a textarea — which never
     parses its contents as markup — then drop any tags that surface. */
  function copyText(s) {
    if (!s) return '';
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  function $(id) { return document.getElementById(id); }
  function setBg(el, url) { el.style.backgroundImage = url ? 'url("' + url + '")' : ''; }

  /* pick the variant matching every real (Shopify-backed) option choice */
  function matchVariant() {
    if (!current) return null;
    var real = current.options;
    if (!real.length) return current.variants[0] || null;
    for (var i = 0; i < current.variants.length; i++) {
      var v = current.variants[i], ok = true;
      for (var j = 0; j < real.length; j++) {
        if (picked[real[j].name] !== v.options[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function refreshPrice() {
    var v = matchVariant();
    var el = $('pdpPrice');
    if (el) el.textContent = v ? v.price : current.price;
    var add = $('pdpAdd');
    if (add) {
      var out = v && !v.available;
      add.querySelector('span').textContent = out ? 'Sold out' : 'Add to bag';
      add.disabled = !!out;
      add.style.opacity = out ? '.45' : '';
      add.style.cursor = out ? 'not-allowed' : '';
    }
  }

  function openPDP(card) {
    var raw = card.querySelector('.stndr-data');
    if (!raw) return;
    var p;
    try { p = JSON.parse(raw.textContent); } catch (e) { return; }

    current = p; picked = {}; virtualSize = null;
    lastFocus = document.activeElement;

    /* design-reference copy fills anything the Shopify product hasn't set yet */
    var fb = (window.STNDR_FALLBACK || {})[p.code] || {};

    $('pdpCode').textContent = p.code;
    $('pdpName').textContent = p.name;
    $('pdpPrice').textContent = p.price;
    $('pdpDetails').textContent = copyText(p.details) || fb.details || '';
    $('pdpCare').textContent = copyText(p.care) || fb.care || '';
    $('pdpSizeMsg').textContent = '';
    $('pdpShot').textContent = '';

    /* gallery */
    var main = $('pdpMain');
    setBg(main, p.images[0]);
    var th = $('pdpThumbs');
    th.innerHTML = '';
    p.images.forEach(function (url, i) {
      var d = document.createElement('button');
      d.className = 'thumb' + (i === 0 ? ' on' : '');
      d.setAttribute('aria-label', 'View image ' + (i + 1));
      var im = document.createElement('div');
      im.className = 'im';
      setBg(im, url);
      d.appendChild(im);
      d.addEventListener('click', function () {
        setBg(main, url);
        th.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('on'); });
        d.classList.add('on');
      });
      th.appendChild(d);
    });

    /* colour — real Shopify option when present */
    var colourOpt = null, sizeOpt = null;
    p.options.forEach(function (o) {
      if (!colourOpt && isColour(o.name)) colourOpt = o; else if (!sizeOpt) sizeOpt = o;
    });

    var colourBlock = $('pdpColourBlock');
    var sw = $('pdpSw');
    sw.innerHTML = '';
    if (colourOpt) {
      colourBlock.hidden = false;
      picked[colourOpt.name] = colourOpt.values[0].name;
      $('pdpColour').textContent = colourOpt.values[0].name;
      $('pdpShot').textContent = 'Photography shows ' + colourOpt.values[0].name + '.';
      colourOpt.values.forEach(function (c, i) {
        var b = document.createElement('button');
        b.className = 'sw' + (i === 0 ? ' on' : '');
        b.style.background = c.hex;
        b.title = c.name;
        b.setAttribute('aria-label', c.name);
        b.addEventListener('click', function () {
          picked[colourOpt.name] = c.name;
          sw.querySelectorAll('.sw').forEach(function (s) { s.classList.remove('on'); });
          b.classList.add('on');
          $('pdpColour').textContent = c.name;
          $('pdpShot').textContent = i === 0
            ? 'Photography shows ' + colourOpt.values[0].name + '.'
            : 'Photography shows ' + colourOpt.values[0].name + ' — ' + c.name + ' images coming soon.';
          refreshPrice();
        });
        sw.appendChild(b);
      });
    } else {
      colourBlock.hidden = true;
    }

    /* size — a real Shopify option if the product has one, otherwise the
       house size run, recorded on the order as a line item property */
    var sizeBlock = $('pdpSizeBlock');
    var sz = $('pdpSizes');
    sz.innerHTML = '';
    var sizeValues = sizeOpt ? sizeOpt.values.map(function (v) { return v.name; }) : fb.sizes;
    var sizeName = sizeOpt ? sizeOpt.name : 'Size';
    $('pdpSizeLabel').textContent = sizeName;

    if (sizeValues && sizeValues.length) {
      sizeBlock.hidden = false;
      sizeValues.forEach(function (s) {
        var b = document.createElement('button');
        b.className = 'size lbl';
        b.textContent = s;
        b.addEventListener('click', function () {
          if (sizeOpt) picked[sizeOpt.name] = s; else virtualSize = s;
          sz.querySelectorAll('.size').forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          $('pdpSizeMsg').textContent = '';
          refreshPrice();
        });
        sz.appendChild(b);
      });
    } else {
      sizeBlock.hidden = true;
    }

    /* size guide */
    var rows = GUIDE[p.fit || fb.fit] || GUIDE.top;
    var t = '<p style="margin-bottom:.7rem">Measurements in centimetres, garment laid flat.</p><table><tr>' +
      rows[0].map(function (h) { return '<th>' + h + '</th>'; }).join('') + '</tr>';
    rows.slice(1).forEach(function (r) {
      t += '<tr>' + r.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    });
    $('guideBox').innerHTML = t + '</table>';

    pdp.querySelectorAll('.acc').forEach(function (a) { a.classList.remove('on'); });
    refreshPrice();
    $('pdpBody').scrollTop = 0;
    pdp.classList.add('open');
    body.classList.add('lock');
    setTimeout(function () { pdp.querySelector('.pdp__close').focus(); }, 100);
  }

  function closePDP() {
    pdp.classList.remove('open');
    body.classList.remove('lock');
    if (lastFocus) lastFocus.focus();
  }

  if (pdp) {
    pdp.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closePDP); });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pdp.classList.contains('open')) closePDP();
    });

    document.querySelectorAll('.card').forEach(function (c) {
      c.setAttribute('tabindex', '0');
      c.addEventListener('click', function () { openPDP(c); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPDP(c); }
      });
    });

    $('pdpAdd').addEventListener('click', function () {
      if (!current) return;
      var sizeOpt = current.options.filter(function (o) { return !isColour(o.name); })[0];
      var sizeValue = sizeOpt ? picked[sizeOpt.name] : virtualSize;

      if (!$('pdpSizeBlock').hidden && !sizeValue) {
        $('pdpSizeMsg').textContent = 'Choose a size first.';
        return;
      }
      var v = matchVariant();
      if (!v) { $('pdpSizeMsg').textContent = 'That combination is unavailable.'; return; }

      var payload = { id: v.id, quantity: 1 };
      if (virtualSize) payload.properties = { Size: virtualSize };

      var btn = this;
      btn.disabled = true;
      fetch(CFG.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [payload] })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        btn.disabled = false;
        if (!res.ok) { say(res.d.description || res.d.message || 'Could not add to bag'); return; }
        var label = current.name;
        var colourOpt = current.options.filter(function (o) { return isColour(o.name); })[0];
        if (colourOpt) label += ', ' + picked[colourOpt.name];
        if (sizeValue) label += ', ' + sizeValue;
        say(label + ' added to bag');
        return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setBag(cart.item_count); });
      }).catch(function () {
        btn.disabled = false;
        say('Could not add to bag');
      });
    });

    pdp.querySelectorAll('.acc__h').forEach(function (h) {
      h.addEventListener('click', function () { h.parentElement.classList.toggle('on'); });
    });
    $('sizeLink').addEventListener('click', function () {
      var a = $('accGuide');
      a.classList.add('on');
      a.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- newsletter ---------- */
  var btn = document.getElementById('joinBtn');
  var inp = document.getElementById('email');
  var note = document.getElementById('note');
  if (btn && inp && note) {
    btn.addEventListener('click', function () {
      var v = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        note.textContent = 'Enter a full email address, like name@example.com.';
        inp.focus();
        return;
      }
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[tags]', 'newsletter');
      fd.append('contact[email]', v);
      btn.disabled = true;
      fetch('/contact', { method: 'POST', body: fd })
        .then(function () {
          note.textContent = 'Signed up. Your code is on its way.';
          inp.value = '';
        })
        .catch(function () { note.textContent = 'Something went wrong. Try again in a moment.'; })
        .then(function () { btn.disabled = false; });
    });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); btn.click(); } });
  }
})();
